document.addEventListener("DOMContentLoaded", function() {
  const TWELVE_HOURS = 12 * 60 * 60 * 1000;
  const currentTime = new Date().getTime();

  var visitedProducts = sessionStorage.getItem("visitedProducts");
  var timestamp = sessionStorage.getItem("timestamp");

  if (timestamp && currentTime - parseInt(timestamp) > TWELVE_HOURS) {
    sessionStorage.clear();
    visitedProducts = null;
  }

  if (!visitedProducts) {
    visitedProducts = {};
    sessionStorage.setItem("timestamp", currentTime);
  } else {
    try {
      visitedProducts = JSON.parse(visitedProducts);
    } catch (e) {
      visitedProducts = {};
    }
  }

  var productElement = document.getElementById("product-data");
  if (!productElement) {
    return;
  }
  var productId = productElement.getAttribute("data-product-id");

  var stockValue;
  if (visitedProducts[productId] !== undefined) {
    stockValue = visitedProducts[productId];
    var decrement = Math.floor(Math.random() * 2) + 1;
    stockValue = Math.max(1, stockValue - decrement);
  } else {
    stockValue = Math.floor(Math.random() * 10) + 1;
  }

  visitedProducts[productId] = stockValue;
  sessionStorage.setItem("visitedProducts", JSON.stringify(visitedProducts));
  sessionStorage.setItem("timestamp", currentTime);

  var stockElement = document.getElementById("dynamic-stock");
  if (stockElement) {
    stockElement.innerText = "Only " + stockValue + " left in stock";
  }
});
